"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M2.713 3.958a1 1 0 01.574-1.916l10 3c.95.285.95 1.63 0 1.916l-10 3a1 1 0 01-.574-1.916L9.52 6 2.713 3.958zM3 12h10a1 1 0 010 2H3a1 1 0 010-2z"];
//# sourceMappingURL=greater-than-or-equal-to.js.map